import React, { useCallback, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Form } from 'semantic-ui-react'
import { AddBtn } from '../../../commonComponents/AddBtn'
import { FormTitle } from '../../../commonComponents/FormTitle'
import List from '../../../commonComponents/List'
import SupplyChainActorDetails from './supplyChainActorDetails'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import { useDocument } from '../../hooks/useDocument'
import { saveMultipleTabsValue } from '../../api/saveNLdata'
import {
  createMultipleTabsInItem,
  deleteMultipleTabsInItem,
  updateMultipleLineData,
} from '../../actions'

const SupplyChainActor = (props) => {
  const isFormEnabled = false
  const dispatch = useDispatch()
  const { merchandiseId, declarationType, invoiceId, lineItemIndex } = props
  const key = 'additionalSupplyChainActor'

  const [isLoading, setisLoading] = useState(false)
  const additionalSupplyChainList =
    useSelector(
      (state) =>
        state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.additionalSupplyChainActor
    ) || []
  const updateLoadingStatus = () => {
    setisLoading(false)
  }
  const createSupplyChain = () => {
    setisLoading(true)

    dispatch(
      createMultipleTabsInItem(invoiceId, merchandiseId, declarationType, key, updateLoadingStatus)
    )
  }
  const deleteSupplyChain = (id) => {
    setisLoading(true)

    dispatch(
      deleteMultipleTabsInItem(
        invoiceId,
        merchandiseId,
        declarationType,
        key,
        id,
        updateLoadingStatus
      )
    )
  }
  const updateSupplyChain = (id, payload) => {
    let [fieldName, value] = Object.entries(payload)[0]
    dispatch(updateMultipleLineData(invoiceId, merchandiseId, id, key, fieldName, value))
  }
  const saveSupplyChain = (payload) => {
    saveMultipleTabsValue(invoiceId, merchandiseId, declarationType, key, payload)
  }

  const renderItem = useCallback(
    (item) => {
      return (
        <SupplyChainActorDetails
          key={item.infoId}
          item={item}
          isFormEnabled={isFormEnabled}
          updateData={updateSupplyChain}
          deleteData={deleteSupplyChain}
          saveData={saveSupplyChain}
        />
      )
    },
    [isFormEnabled, updateSupplyChain, deleteSupplyChain]
  )
  return (
    <Form.Group className='float-container'>
      <FormTitle title='ADDITIONAL SUPPLY CHAIN ACTOR'></FormTitle>
      <List renderItem={renderItem} dataSource={additionalSupplyChainList} />

      {isLoading && <CustomLoader />}
      {additionalSupplyChainList?.length < 99 && (
        <AddBtn
          disabled={isFormEnabled}
          onClick={createSupplyChain}
          text='Add additional supply chain actor'
        ></AddBtn>
      )}
    </Form.Group>
  )
}

export default React.memo(SupplyChainActor)
